<!--- COMPONENTE PCConfiguracionPuntoPaletizado  ---->
<!---
Descripción del componente:
---------------------------
- Muestra las opciones configurables de un punto de paletizado

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div
    class="div-PCConfiguracionPuntoPaletizadoContenido"
  >
    <!-- BLOQUE OPERACIONES PERSONALIZADAS PUNTO PALETIZADO -->
    <section v-show="hasActions">
      <div class="block-title">
        {{ $t('production.palletizingPointConfiguration.actions.title') }}
      </div>

      <div class="list simple-list margin-left margin-right">
        <div
          ref="actionsListRef"
          class="element-list"
        >
          <PCOperacionesPersonalizadas
            :activo="activo && puntoPaletizado != null ? true : false"
            :app-theme="appTheme"
            :entidad="puntoPaletizado"
            :tipo-entidad="0"
            formulario-padre="frmPaletizado"
            :mostrar-precarga="true"
          />
        </div>
      </div>
    </section>

    <section>
      <!-- BLOQUE UBICACIÓN PALÉS -->
      <div class="block-title">
        {{ $t('production.palletizingPointConfiguration.destinationLocations.title') }}
      </div>
      <div class="list simple-list margin-left margin-right">
        <div class="element-list">
          <!-- <UCUbicaciones
            :disabled="puntoPaletizado != null && !puntoPaletizado.PermitirModificarUbicacion"
            :app-theme="appTheme"
            :mostrar-titulo="false"
            titulo="UBICACIÓN DESTINO PALÉS PRODUCIDOS"
            plantilla="P2"
            :valor-por-defecto="ubicacionPalesProducidos"
            @change="UbicacionDestinoPalesModificada"
          /> -->
          <UCSearchEntityERP
            :placeholder="$t('common.location')"
            :search-text="$t('searchEntity.location.searchText')"
            :search-cancellation-text="$t('searchEntity.location.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.location.searchNotFoundText')"
            :default-value="ubicacionPalesProducidos"
            :end-point-for-code-search="obtenerUbicacionPorCodigo"
            :end-point-for-list="obtenerUbicaciones"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :min-text-search="0"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            :disabled="puntoPaletizado != null && !puntoPaletizado.PermitirModificarUbicacion"
            @selection="EventUbicacionesSelected"
          />
        </div>
      </div>
    </section>

    <section>
      <!-- BLOQUE UBICACIÓN PALÉS -->
      <div class="block-title">
        {{ $t('production.palletizingPointConfiguration.activePallet.title') }}
      </div>
      <div class="list simple-list margin-left margin-right active-pallet-list">
        <div class="element-list active-pallet-list__item">
          <div>
            {{ $t('production.palletizingPointConfiguration.activePallet.show') }}
          </div>
          <div>
            <f7-toggle v-model:checked="activePalletSettings.view" />
          </div>
        </div>

        <template v-if="activePalletSettings.view">
          <div class="element-list active-pallet-list__item">
            <div>
              {{ $t('production.palletizingPointConfiguration.activePallet.showSalesOrder') }}
            </div>
            <div>
              <f7-toggle v-model:checked="activePalletSettings.showSalesOrder" />
            </div>
          </div>
          <div class="element-list active-pallet-list__item">
            <div>
              {{ $t('production.palletizingPointConfiguration.activePallet.showCustomerName') }}
            </div>
            <div>
              <f7-toggle v-model:checked="activePalletSettings.showCustomerName" />
            </div>
          </div>

          <div class="element-list active-pallet-list__item">
            <div>
              {{ $t('production.palletizingPointConfiguration.activePallet.showSerialNumber') }}
            </div>
            <div>
              <f7-toggle v-model:checked="activePalletSettings.showSerialNumber" />
            </div>
          </div>

          <div class="element-list active-pallet-list__item">
            <div>
              {{ $t('production.palletizingPointConfiguration.activePallet.showProduct') }}
            </div>
            <div>
              <f7-toggle v-model:checked="activePalletSettings.showProduct" />
            </div>
          </div>

          <div class="element-list active-pallet-list__item">
            <div>
              {{ $t('production.palletizingPointConfiguration.activePallet.showPackage') }}
            </div>
            <div>
              <f7-toggle v-model:checked="activePalletSettings.showPackage" />
            </div>
          </div>

          <div class="element-list active-pallet-list__item">
            <div>
              {{ $t('production.palletizingPointConfiguration.activePallet.showPallet') }}
            </div>
            <div>
              <f7-toggle v-model:checked="activePalletSettings.showPallet" />
            </div>
          </div>

          <div class="element-list active-pallet-list__item">
            <div>
              {{ $t('production.palletizingPointConfiguration.activePallet.showPackagesPerPallet') }}
            </div>
            <div>
              <f7-toggle v-model:checked="activePalletSettings.showPackagesPerPallet" />
            </div>
          </div>
        </template>
      </div>
    </section>

    <!-- BLOQUE BOTONES CONFIRMAR/CANCELAR -->
    <div class="div-elementoSeparador-90 div-separador" />
    <div class="div-opcionesActions">
      <f7-row>
        <f7-col
          width="50"
          class="col-izquierdaActions"
        >
          <a
            class="link link-izquierdaActions-2"
            @click="CancelarEdicion()"
          > {{ $t('common.cancel').toUpperCase() }} </a>
        </f7-col>
        <f7-col
          width="50"
          class="col-derechaActions"
        >
          <a
            class="link link-derechaActions-2"
            @click="ConfirmarEdicion()"
          >{{ $t('common.confirm').toUpperCase() }}</a>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
import { computed, shallowRef } from 'vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import PCOperacionesPersonalizadas from '@/components/production/traceability/PCOperacionesPersonalizadas.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { useSettingRef } from '@erpagroapp/settings';

/** @import { ShallowRef } from 'vue' */

export default {
  name: 'PCConfiguracionPuntoPaletizado',
  components: {
    PCOperacionesPersonalizadas,
    UCSearchEntityERP,
  },
  props: {
    puntoPaletizado: { type: Object, default: null },
    appTheme: { type: Object, default: null },
    activo: { type: Boolean, default: false },
  },

  emits: [
    'cerrarFrm',
    'change',
  ],

  setup() {
    /** @type {ShallowRef<InstanceType<typeof HTMLDivElement> | null} */
    const actionsListRef = shallowRef(null);
    const hasActions = computed(() => actionsListRef.value?.children.length !== 0);

    return {
      actionsListRef,
      hasActions,
    };
  },

  data() {
    return {
      configuracion: { UbicacionDestinoPalesProduccidos: null },
      activePalletSettings: {
        view: useSettingRef('Paletizado.PaleActivo.MostrarInformacion'),
        showSalesOrder: useSettingRef('Paletizado.PaleActivo.MostrarPedidoVenta'),
        showCustomerName: useSettingRef('Paletizado.PaleActivo.MostrarNombreCliente'),
        showSerialNumber: useSettingRef('Paletizado.PaleActivo.MostrarNumeroSerie'),
        showProduct: useSettingRef('Paletizado.PaleActivo.MostrarProducto'),
        showPackage: useSettingRef('Paletizado.PaleActivo.MostrarEnvase'),
        showPallet: useSettingRef('Paletizado.PaleActivo.MostrarPale'),
        showPackagesPerPallet: useSettingRef('Paletizado.PaleActivo.MostrarEnvasesPorPale'),
      },
    };
  },
  computed: {
    ubicacionPalesProducidos() {
      return this.puntoPaletizado != null ? this.puntoPaletizado.UbicacionPalesProducidos : null;
    },
  },

  methods: {

    CancelarEdicion() {
      Log(this, this.CancelarEdicion.name);
      this.RestablecerValores();
      this.$emit('cerrarFrm');
    },

    ConfirmarEdicion() {
      Log(this, this.ConfirmarEdicion.name);
      this.$emit('change', this.configuracion);
      this.RestablecerValores();
    },

    RestablecerValores() {
      Log(this, this.RestablecerValores.name);
    },

    /* UbicacionDestinoPalesModificada(objNuevaUbicacion) {
      Log(this, this.UbicacionDestinoPalesModificada.name);
      this.configuracion.UbicacionDestinoPalesProduccidos = objNuevaUbicacion;
    }, */
    EventUbicacionesSelected(obj) {
      Log(this, this.EventUbicacionesSelected.name);
      this.configuracion.UbicacionDestinoPalesProduccidos = obj;
    },

    obtenerUbicacionPorCodigo(params) {
      Log(this, this.obtenerUbicacionPorCodigo.name);
      return ConexionTA.callObtenerUbicacionPorCodigo(params);
    },
    obtenerUbicaciones() {
      Log(this, this.obtenerUbicaciones.name);
      return ConexionTA.callObtenerUbicaciones();
    },
  },
};
</script>

<style scoped lang="scss">
.div-PCConfiguracionPuntoPaletizadoContenido {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.div-opcionesActions {
  width: 94%;
  left: 0;
  bottom: 0;
  position: absolute;
}

.div-separador {
  width: 94%;
  left: 0;
  bottom: 45px;
  position: absolute;
}

.block-title {
  color: #253858;
  font-size: 16px;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
}

.element-list {
  margin-right: 25px;
}

.active-pallet-list {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: var(--f7-typography-margin);
  }
}
</style>
